export default function AboutPage() {
  return (
    <div className="py-12 bg-white">
      <div className="container mx-auto px-4 md:px-8 lg:px-12">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-4xl md:text-5xl font-playfair font-bold text-foreground mb-6">About InsideHigherEducation</h1>
          
          <div className="prose prose-lg max-w-none text-muted-foreground space-y-6">
            <p className="text-lg leading-relaxed">
              InsideHigherEducation is your trusted source for comprehensive information about higher education opportunities worldwide. We are dedicated to helping students, professionals, and lifelong learners make informed decisions about their educational journey.
            </p>

            <h2 className="text-2xl font-playfair font-bold text-foreground mt-8 mb-4">Our Mission</h2>
            <p className="leading-relaxed">
              Our mission is to democratize access to quality education information by providing accurate, up-to-date content about universities, online courses, scholarships, and career development opportunities across the United States and Europe.
            </p>

            <h2 className="text-2xl font-playfair font-bold text-foreground mt-8 mb-4">What We Offer</h2>
            <ul className="list-disc ml-6 space-y-2">
              <li>Comprehensive university rankings and profiles</li>
              <li>Detailed information about study programs in the USA and Europe</li>
              <li>Curated online courses and certification programs</li>
              <li>Scholarship and funding opportunities</li>
              <li>High-income skills and career development guidance</li>
              <li>Latest news and trends in higher education</li>
            </ul>

            <h2 className="text-2xl font-playfair font-bold text-foreground mt-8 mb-4">Our Values</h2>
            <p className="leading-relaxed">
              We believe in accuracy, transparency, and accessibility. Our team of education experts works tirelessly to verify information, provide unbiased analysis, and present content in a way that empowers our readers to make the best choices for their future.
            </p>

            <h2 className="text-2xl font-playfair font-bold text-foreground mt-8 mb-4">Contact Information</h2>
            <p className="leading-relaxed">
              <strong>Email:</strong> <a href="mailto:contact@insidehighereducation.eu" className="text-accent hover:underline">contact@insidehighereducation.eu</a>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}